import { AppSettingsModule } from 'services/settings.provider';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { FeaturesServiceModule } from 'services/access/features/features.service';
import { OnboardingServiceModule } from 'services/data/onboarding.service';
import { DataServiceModule } from './data.service';

export const LandingServiceModule = angular
    .module('app.services.data.landingService', [
        AppSettingsModule,
        LaunchDarklyServiceModule,
        FeaturesServiceModule,
        OnboardingServiceModule,
        DataServiceModule
    ]).service('landingService', (
        settings,
        dataService,
        featureService,
        DEFAULT_APPS
    ) => {
        function getItems(includeDefault = true) {
            return featureService.getInstalledApps().then((installedApps) => {
                let apps = [];
                if (includeDefault) apps = angular.copy(DEFAULT_APPS);

                if (installedApps.discounts) {
                    apps.push({
                        type: 'discounts',
                        sku: 'discounts',
                        label: 'LABEL.DISCOUNTS',
                        link: 'discounts.list',
                        svgSrc: '/assets/percent.svg',
                        color: '#44D1A3',
                        hideInQuickMenu: true
                    });
                }
                if (installedApps.shipping) {
                    apps.push({
                        type: 'postage',
                        sku: 'shipping',
                        label: 'POSTAGE.LABEL',
                        icon: 'local_shipping',
                        link: 'postage.edit',
                        color: '#03A9F4',
                        svgSrc: '/assets/shippo.svg',
                        hideInQuickMenu: true
                    });
                }
                if (installedApps.pinterest) {
                    apps.push({
                        type: 'pinterest',
                        sku: 'pinterest',
                        label: 'LABEL.PINTEREST',
                        link: 'pinterest',
                        color: '#BD081C',
                        svgSrc: '/assets/pinterest.svg',
                        hideInQuickMenu: true
                    });
                }
                if (installedApps.facebookPixel) {
                    apps.push({
                        type: 'facebookPixel',
                        sku: 'facebookPixel',
                        label: 'LABEL.FACEBOOKPIXEL',
                        link: 'facebookPixel',
                        color: '#3A5A98',
                        icon: 'code',
                        hideInQuickMenu: true
                    });
                }
                if (installedApps.zapier) {
                    apps.push({
                        type: 'zapier',
                        sku: 'zapier',
                        label: 'LABEL.ZAPIER',
                        link: 'zapier',
                        color: '#FF4A00',
                        svgSrc: '/assets/zapier_icon_reverse.svg',
                        hideInQuickMenu: true
                    });
                }
                if (installedApps.avalara) {
                    apps.push({
                        type: 'avalara',
                        sku: 'avalara',
                        label: 'LABEL.AVALARA',
                        link: 'avalara',
                        externalLink: '/admin/avalara',
                        color: '#FFFFFF',
                        svgSrc: '/assets/avalara.svg',
                        hideInQuickMenu: true
                    });
                }

                if (installedApps.fullstory) {
                    apps.push({
                        type: 'fullstory',
                        sku: 'fullstory',
                        label: 'LABEL.FULLSTORY',
                        link: 'fullstory',
                        color: '#F0617D',
                        svgSrc: '/assets/fullstoryLogo.svg',
                        hideInQuickMenu: true
                    });
                }

                if (installedApps.privy) {
                    apps.push({
                        type: 'privy',
                        sku: 'privy',
                        label: 'LABEL.PRIVY',
                        link: 'privy',
                        color: '#57C9AC',
                        svgSrc: '/assets/privy-logo.svg',
                        hideInQuickMenu: true
                    });
                }

                if (installedApps.fulfillers) {
                    apps.push({
                        type: 'fulfillers',
                        sku: 'fulfillers',
                        label: 'LABEL.FULFILLERS',
                        link: 'fulfillers.list',
                        color: '#4747cd',
                        svgSrc: '/assets/fulfillersLogo.svg',
                        hideInQuickMenu: true
                    });
                }

                if (installedApps.mailchimp) {
                    apps.push({
                        type: 'mailchimp',
                        sku: 'mailchimp',
                        label: 'LABEL.MAILCHIMP',
                        hideInQuickMenu: true,
                        svgSrc: '/assets/mailchimp_logo.svg',
                        link: 'mailchimp',
                        color: '#52BAD5'
                    });
                }

                if (installedApps.yotpo) {
                    apps.push({
                        type: 'yotpo',
                        sku: 'yotpo',
                        label: 'LABEL.YOTPO',
                        link: 'yotpo',
                        color: '#2f84ed',
                        svgSrc: '/assets/yotpo.svg'
                    });
                }

                if (installedApps.googleAnalytics) {
                    apps.push({
                        type: 'googleAnalytics',
                        sku: 'googleAnalytics',
                        label: 'LABEL.GOOGLEANALYTICS',
                        link: 'googleAnalytics',
                        color: '#eeeeee',
                        svgSrc: '/assets/GA_icon.svg',
                        hideInQuickMenu: true
                    });
                }

                if (installedApps.chat) {
                    apps.push({
                        type: 'chat',
                        sku: 'chat',
                        label: 'LABEL.CHAT',
                        link: 'chat',
                        color: '#887AAD',
                        svgSrc: '/assets/chat_icon_light.svg',
                        hideInQuickMenu: true
                    });
                }

                if (installedApps.quickbooks) {
                    apps.push({
                        type: 'quickbooks',
                        sku: 'quickbooks',
                        label: 'LABEL.QUICKBOOKS',
                        link: 'quickbooks',
                        color: '#09A639',
                        svgSrc: '/assets/quickbooks_logo.svg'
                    });
                }

                if (installedApps.xero) {
                    apps.push({
                        type: 'xero',
                        sku: 'xero',
                        label: 'LABEL.XERO',
                        link: 'xero',
                        color: '#32B7EF',
                        svgSrc: '/assets/xero_logo.svg'
                    });
                }

                apps.push({
                    type: 'add-app',
                    label: 'LABEL.ADDAPP',
                    icon: 'add',
                    link: 'appstore2.allapps2',
                    color: 'transparent',
                    hideInQuickMenu: true,
                    bypassAnimationOut: true
                });

                return apps;
            });
        }

        function getNewOrdersCount() {
            let options = {
                filter: 'status eq New',
                pageSize: 1
            };

            return dataService.getAll(settings.api.orders, options).then((response) => {
                return response.totalCount;
            });
        }

        return {
            getNewOrdersCount,
            getItems
        };
    }).constant('DEFAULT_APPS', [
        {
            type: 'get-started',
            label: 'LABEL.GET_STARTED',
            icon: 'star',
            color: '#ffab00'
        },
        {
            type: 'orders',
            label: 'LABEL.ORDERS',
            icon: 'shopping_cart',
            link: 'order.list',
            color: '#3EC671',
            hasBadge: true
        },
        {
            type: 'products',
            label: 'LABEL.PRODUCTS',
            icon: 'local_offer',
            link: 'product.list',
            color: '#0FB3CC'
        },
        {
            type: 'categories',
            label: 'LABEL.CATEGORIES',
            icon: 'list',
            link: 'category.list',
            color: '#1E66C3'
        },
        {
            type: 'customers',
            label: 'LABEL.CUSTOMERS',
            icon: 'people',
            link: 'customer.list',
            color: '#684BB6'
        },
        {
            type: 'pages',
            label: 'LABEL.PAGES',
            icon: 'insert_drive_file',
            link: 'pages.list',
            color: '#79729d',
            linkedApp: true
        },
        {
            type: 'app-store',
            label: 'LABEL.APPSTORE',
            icon: 'apps',
            link: 'appstore2.installedapps2',
            color: '#EC6060'
        },
        {
            type: 'settings',
            label: 'LABEL.STORESETTINGS',
            icon: 'settings',
            color: '#FF8055',
            link: 'settings.detail',
            hasBadge: true
        },
        {
            type: 'edit-menu',
            label: 'Menu Editor',
            icon: 'menu',
            link: 'editstore.menu',
            color: '#79729d',
            linkedAppEnd: true
        },
        {
            type: 'analytics',
            label: 'LABEL.ANALYTICS',
            icon: 'trending_up',
            link: 'analytics.main',
            color: '#4D98F0'
        },
        {
            type: 'designer',
            icon: 'layers',
            link: 'designer',
            label: 'LABEL.SITE_DESIGNER',
            color: '#79729d',
            linkedAppStart: true
        }
    ]).name;



// WEBPACK FOOTER //
// ./src/app/services/data/landing.service.js